import { render, staticRenderFns } from "./DUserMenu.vue?vue&type=template&id=25386630"
import script from "./DUserMenu.vue?vue&type=script&lang=js"
export * from "./DUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports